module.exports = __webpack_public_path__ + "img/bespoke123_10.057c707a.jpg";